import {
    CITY_CUTOFF,
    CITY_NAME_DEFAULT_CUT,
    CITY_NAME_SHORT_CUT,
} from '../../../../constants';

/*
 Receives a city name and splits it in two according
 to its length:

 @param city - string

 @return object {firstCityName: 'San ', secondCityName: 'Francisco'}
*/
export const splitCityName = (city: string) => {
    let cityToParse = city;

    if (!city) {
        cityToParse = '';
    }

    cityToParse = cityToParse.split(',')[0];
    const cityNameLength = cityToParse.length;

    let firstLength = CITY_NAME_DEFAULT_CUT;

    if (cityNameLength >= firstLength && cityNameLength < CITY_CUTOFF) {
        firstLength = CITY_NAME_SHORT_CUT;
    }

    return {
        firstCityName: cityToParse.substring(0, firstLength),
        secondCityName: cityToParse.substring(firstLength, cityNameLength),
    };
};
